import { pluralizeWord } from '@npm-registry/helpers/pluralize';
import { useSelector } from 'react-redux';
import { text } from '../../../../text';
import { selectPreorderCount } from '../../../../store/summary';

export const usePreorder = () => {
  const count: number = useSelector(selectPreorderCount);
  const itemsLabel: string = pluralizeWord(count, [
    text['oneItem'],
    text['fewItems'],
    text['manyItems']
  ]);
  const formalizeLabel: string = pluralizeWord(count, [
    text['preorder.banner.formalize'],
    text['preorder.banner.formalize.items'],
    text['preorder.banner.formalize.items']
  ]);

  return {
    count,
    itemsLabel,
    formalizeLabel
  };
};
